import { Reducer } from 'redux'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { createEmptyFetchable, createFetchableReducer } from 'helpers/loadableHelpers'
import { AdvisorsPatchReviewAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'

const defReducer = createFetchableReducer<null>()
export const reviewRequestReducer: Reducer<AdvisorDataState['reviewRequest']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case AdvisorsPatchReviewAction.type: {
      return defReducer(prevState, action)
    }
  }
  return prevState
}
